<div class="row text-center toasty-position-class">
  <div class="col">
    <div class="header-icon margin-bottom mb8">
      <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
        <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
    </ng-container>
    <ng-template #acmicCloseIcon>
        <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
    </ng-template>
    </div>
    <h1 class="title-copy font-weight-normal">{{ 'LETS_VERIFY_YOUR_ACCOUNT' | translate }}</h1>
    <div class="sub-title-copy grey-color">
      {{ 'EMAIL_VERIFICATION_SUBJECT_TITLE' | translate }}
    </div>
    <div class="sub-title-copy grey-color margin-bottom mb24">
      <strong>
        {{email}}
      </strong>
    </div>
  </div>
</div>
  <div class="row text-center">
    <div class="col">
      <div class="account-settings margin-bottom mb8">
        {{ 'DID_NOT_RECEIVE_EMAIL' | translate }}
      </div>
      <div class="sub-title-copy grey-color content-w-320">
        {{ 'CHECK_YOUR_SPAM_MESSAGES' | translate }}
        <span class="font-bold">
          {{ 'SUBJECT_EMAIL' | translate }}
        </span>
      </div>
      <div class="margin-top mt24 margin-bottom mb8 ma-red-link">      
        <mapfre-link (click)="sendEmail()" [additionalClasses]="'red-link underlineBQ dm-sans-medium fs-16'">
          <div>
            {{ 'RESEND_VERIFICATION_EMAIL' | translate }}
          </div>
        </mapfre-link>
      </div>
    </div>
  </div>